import api from './api'

export const monitor = {
    retrieve,
    metrics,
    save
};

function retrieve() {
    return api.get('/monitors', {
        params: {page: 1, limit: 320, sort: "url"}
    })
        .then(function (response) {
            if (response.data) {
                return response;
            }
        })
        .catch(function (error) {
            return Promise.reject(error);
        });
}

function metrics(monitor, url_parameters) {
    return api.get('/monitors/' + monitor.id + '/metrics', {
        params: url_parameters
    })
        .then(function (response) {
            if (response.data) {
                return response;
            }
        })
        .catch(function (error) {
            return Promise.reject(error);
        });
}

function save(monitor) {
    return api[monitor.id === '' ? 'post' : 'put']('/monitors' + (monitor.id !== '' ? '/' + monitor.id : ''), monitor)
        .then(function (response) {
            if (response.data) {
                return response;
            }
        })
        .catch(function (error) {
            return Promise.reject(error);
        });
}


export default monitor